"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = generatePayload;
var _utils = require("../../middleware/utils");
function calculateAge(day, month, year) {
  var dob = new Date(month + '/' + day + '/' + year);
  //calculate month difference from current date in time
  var diff_ms = Date.now() - dob.getTime();
  var age_dt = new Date(diff_ms);
  return Math.abs(age_dt.getUTCFullYear() - 1970);
}
function generatePayload(values) {
  var payload = {};
  /* istanbul ignore next */
  function setFieldIfExists(fieldName, value, forcedValue) {
    if (value !== '' && value !== undefined) {
      payload[fieldName] = value;
    } else if (forcedValue || forcedValue === 0) {
      payload[fieldName] = forcedValue;
    }
  }
  var reportedAge = calculateAge(values.birthDay, values.birthMonth, values.birthYear);
  var spouseAge = calculateAge(values.spouseBirthDay, values.spouseBirthMonth, values.spouseBirthYear);
  var ageDifference = Math.abs(reportedAge - spouseAge);
  var beneficiaryMap = {
    'my spouse': 'spouse',
    'not my spouse': 'not_spouse'
  };
  var rateOfReturnMap = {
    '0%': 0,
    '1%': 1,
    '2%': 2,
    '3%': 3,
    '4%': 4,
    '5%': 5,
    '6%': 6,
    '7%': 7,
    '8%': 8,
    '9%': 9,
    '10%': 10
  };
  var spouseBirthDay, spouseBirthMonth, spouseBirthYear;
  if (values.beneficiary == 'not my spouse') {
    spouseBirthDay = (0, _utils.parseCurrencyString)(null, values.birthDay);
    spouseBirthMonth = (0, _utils.parseCurrencyString)(null, values.birthMonth);
    spouseBirthYear = (0, _utils.parseCurrencyString)(null, values.birthYear);
    spouseAge = reportedAge;
    ageDifference = 0;
  } else {
    spouseBirthDay = (0, _utils.parseCurrencyString)(null, values.spouseBirthDay);
    spouseBirthMonth = (0, _utils.parseCurrencyString)(null, values.spouseBirthMonth);
    spouseBirthYear = (0, _utils.parseCurrencyString)(null, values.spouseBirthYear);
  }

  // Start all REQUIRED general fields
  setFieldIfExists('account_balance', (0, _utils.parseCurrencyString)(null, values.accountBalance));
  setFieldIfExists('beneficiary_type', beneficiaryMap[values.beneficiary]);
  setFieldIfExists('rate_of_return', (0, _utils.parseCurrencyString)(null, rateOfReturnMap[values.rateOfReturn]));
  setFieldIfExists('retiree_birth_day', (0, _utils.parseCurrencyString)(null, values.birthDay));
  setFieldIfExists('retiree_birth_month', (0, _utils.parseCurrencyString)(null, values.birthMonth));
  setFieldIfExists('retiree_birth_year', (0, _utils.parseCurrencyString)(null, values.birthYear));
  setFieldIfExists('spouse_birth_day', spouseBirthDay);
  setFieldIfExists('spouse_birth_month', spouseBirthMonth);
  setFieldIfExists('spouse_birth_year', spouseBirthYear);
  setFieldIfExists('retiree_reported_age', reportedAge);
  setFieldIfExists('spouse_reported_age', spouseAge);
  setFieldIfExists('age_difference', ageDifference);
  return payload;
}